import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:Auth');

const GROUP_SALESREP = 'Sales Representative';
export const LOGIN_TYPES = {
  EMAIL: 'email',
  SSO: 'sso',
};

export default class AuthService {
  constructor($context, adApiService, apiKeyService, localeService) {
    this.vue = $context;
    this.adApiService = adApiService;
    this.apiKeyService = apiKeyService;
    this.localeService = localeService;

    this.vue.$root.$on('logout:force', () => this.logout());
  }

  login(email, password, remember = false) {
    debug.info('trying to login as %s', email);
    return this.adApiService.login(email, password)
      .then(token => {
        this.apiKeyService.setKey(token);
        this.apiKeyService.toPersistance(token, remember);
        this.vue.$cookie.set('login_type', LOGIN_TYPES.EMAIL);
      })
      .then(() => this.updateUser())
      .catch(err => {
        this.logout(false);
        throw err;
      });
  }

  logout(redirect = true) {
    debug.info('logout');
    const loginType = this.vue.$cookie.get('login_type') || LOGIN_TYPES.EMAIL;
    let logoutUrl = 'auth/logout';
    if (loginType === LOGIN_TYPES.SSO) {
      logoutUrl = 'auth/remote/logout';
    }

    const body = { redirectUrl: `${window.location.origin}/login` };
    return this.adApiService.logout(logoutUrl, body)
      .then(result => {
        this.apiKeyService.setKey(null);
        this.apiKeyService.toPersistance(null);
        this.vue.$store.user = null;
        this.vue.$cookie.delete('login_type');

        if (result.redirect) {
          window.location.href = result.redirect;
        } else if (redirect) {
          this.vue.$router.push('/');
        }
      })
      .catch(error => {
        debug.error(error);
        this.apiKeyService.setKey(null);
        this.apiKeyService.toPersistance(null);
        this.vue.$store.user = null;
        this.vue.$cookie.delete('login_type');
      });
  }

  setCookie(name, value) {
    this.vue.$cookie.set(name, value);
  }

  updateUser() {
    return this.adApiService.getCurrentUser()
      .then(user => {
        if (!user.groups.find(g => g.name === GROUP_SALESREP)) {
          throw this.vue.$t('error.email-and-or-password-invalid');
        }
        if (user.selected_language) {
          this.localeService.changeLocale(user.selected_language);
        }
        this.vue.$store.user = user;
      });
  }

  getUser() {
    return (this.vue.$store && this.vue.$store.user) ? this.vue.$store.user : null;
  }
}

Injector.service('authService', ['$context', 'adApiService', 'apiKeyService', 'localeService'], AuthService);



// WEBPACK FOOTER //
// ./src/services/AuthService.js